<template>
	<div class="content-wrapper">
		<app-breadcrumb :page-title="'Parent Profile'" :icon="'user'" />
		<app-lead-parent-profile-card :parentId="id" />
		<div
			v-if="
				personalInfoPropsData ||
				childrenInfoPropsData ||
				financePropsData ||
				passwordChangePropsData ||
				socialLinksPropsData
			"
		>
			<app-tab :tabs="computedTabs" :icon="'user'" />
		</div>
	</div>
</template>

<script>
const ParentProfilePersonalInfo = () => import("./PersonalInformation.vue");
const ParentProfileChildrenInfo = () => import("./ChildrenInfo.vue");
const ParentProfileFinance = () => import("./Finance.vue");
const ParentProfilePasswordChange = () => import("./PasswordChange.vue");
const ParentProfileSocialLinks = () => import("./SocialLinks.vue");

export default {
	name: "ParentProfile",
	data() {
		return {
			id: null,
			personalInfoPropsData: null,
			childrenInfoPropsData: null,
			financePropsData: null,
			passwordChangePropsData: null,
			socialLinksPropsData: null,
			parentProfileTabs: [
				{
					name: "Personal Info",
					title: "Personal Info",
					component: ParentProfilePersonalInfo,
					permission: this.$can(
						"view_list_parent_parentprofile_tab_personalinfo"
					),
					class: "",
				},
				{
					name: "Children Info",
					title: "Children Info",
					component: ParentProfileChildrenInfo,
					permission: this.$can(
						"view_list_parent_parentprofile_tab_childreninfo"
					),
					class: "",
				},
				{
					name: "Finance",
					title: "Finance",
					component: ParentProfileFinance,
					permission: "",
					class: "",
				},
				// {
				// 	name: "Password Change",
				// 	title: "Password Change",
				// 	component: ParentProfilePasswordChange,
				// 	permission: this.$can('view_list_parent_parentprofile_tab_passwordchange'),
				// 	class: "",
				// },
				// {
				// 	name: "Social Links",
				// 	title: "Social Links",
				// 	component: ParentProfileSocialLinks,
				// 	permission: this.$can('view_list_parent_parentprofile_tab_sociallinks'),
				// 	class: "",
				// },
			],
		};
	},
	created() {
		let url = window.location.href;
		this.id = url.split("/").slice(-1)[0].split("?")[0];
		this.fetchData();
	},
	computed: {
		computedTabs() {
			return this.parentProfileTabs.map((tab) => {
				if (tab.name === "Personal Info") {
					return {
						...tab,
						props: this.personalInfoPropsData,
					};
				}
				if (tab.name === "Children Info") {
					return {
						...tab,
						props: this.childrenInfoPropsData,
					};
				}
				if (tab.name === "Finance") {
					return {
						...tab,
						props: this.financePropsData,
					};
				}
				if (tab.name === "Password Change") {
					return {
						...tab,
						props: this.passwordChangePropsData,
					};
				}
				if (tab.name === "Social Links") {
					return {
						...tab,
						props: this.socialLinksPropsData,
					};
				}
				return tab;
			});
		},
	},
	methods: {
		async fetchData() {
			try {
				const parentResponse = await axios.get(
					"/transaction/parent/" + this.id
				);

				// assign data to personalInfoPropsData
				this.personalInfoPropsData = parentResponse.data;

				// assign data to childrenInfoPropsData
				this.childrenInfoPropsData = parentResponse.data;

				// assign data to financePropsData
				this.financePropsData = parentResponse.data;

				// assign data to passwordChangePropsData
				this.passwordChangePropsData = parentResponse.data;

				// assign data to socialLinksPropsData
				this.socialLinksPropsData = parentResponse.data;
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
	},
};
</script>
<style scoped>
.user-profile .card {
	min-height: 190px;
}
</style>
